// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"278":"ba8b9907","672":"f75e0b13"}[chunkId] + ".chunk.css";
};